import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./container.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { selectShowBasicHeader } from 'ace/header';
import * as kagekiri from 'kagekiri';
import equalityFn from 'zustand/shallow';
import { FeatureFlags } from '~/modules/feature_flags';
import { routerStore } from '~/modules/stores/routerStore';
import { isAgentExchange } from '~/modules/utilities/router';
class Container extends LightningElement {
  constructor(...args) {
    super(...args);
    // bound to x-lazy child template via lwc:dynamic attribute
    this.pageComponent = null;
    this.showBasicHeader = false;
  }
  routerStoreCallback({
    pageComponent,
    showBasicHeader
  }) {
    if (isAgentExchange()) {
      this.forceAgentforcePage();
    } else {
      this.pageComponent = pageComponent;
      this.showBasicHeader = showBasicHeader;
    }
  }
  async forceAgentforcePage() {
    this.pageComponent = (await import('pages/collections')).default;
    this.showBasicHeader = false;
  }
  get rootContainerCss() {
    const classList = ['root-container'];
    if (this.showBasicHeader) {
      classList.push('hide-search-bar');
    }
    return classList.join(' ');
  }
  get logoRef() {
    return kagekiri.querySelector('ace-header .header-logo');
  }

  /**
   * This function manages the visibility of the footer to prevent Cumulative Layout Shift (CLS).
   * The footer is hidden until all page components are fully loaded.
   * Once the components are loaded, the footer is displayed.
   *
   * @returns {string} - Returns an empty string to show the footer when page components are loaded.
   *                     Returns 'hide-footer' to hide the footer while components are loading.
   */
  get footerClass() {
    if (this.pageComponent) {
      return '';
    }
    return 'hide-footer';
  }
  get showAgentforceChat() {
    return FeatureFlags.FF_AGENTFORCE_CHAT_BUTTON;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Container, {
  wire: {
    routerStoreCallback: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: routerStore,
          selector: state => ({
            pageComponent: selectPageComponent(state),
            showBasicHeader: selectShowBasicHeader(state)
          }),
          equalityFn
        };
      }
    }
  },
  fields: ["pageComponent", "showBasicHeader"]
});
const __lwc_component_class_internal = _registerComponent(Container, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;
function selectPageComponent(state) {
  return state.pageComponent;
}